/* eslint-disable react/no-danger */

import {useEffect, useRef} from 'react';

const TranslatedLink = ({Element = 'p', message, href, target = '_blank', ...props}) => {
    const ref = useRef(null);

    useEffect(
        () => {
            const element = ref.current;

            if (!element) return;

            const a = element.querySelector('a');

            if (!a) return;

            a.href = href;
            a.target = target;
        },
        [href, target],
    );

    return <Element {...props} ref={ref} dangerouslySetInnerHTML={{__html: message}} />;
};

export default TranslatedLink;
